import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import { SuccessPopUp } from "../../../CommonComponents/SuccessPopUp";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


function AddDisplayCat() {
    let navigate = useNavigate();
    const getToken = sessionStorage.getItem('tokenKey');
    const BASE_URL = process.env.REACT_APP_PP_URL;

    // POST CATEGORY VALUE
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');

    const bodyData = {
        title: title,
        description: description,
    };

    // POSTING CATEGORIES
    const PostData = async (okId) => {
        try {
            const response = await fetch(`${BASE_URL}/admin/v1/display-category/save`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${getToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(bodyData)
            });

            const getRes = await response.json();
            if (getRes.errorCode === 0) {
                if (okId === "addMore") {
                    setTitle('');
                    setDescription('');
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'  // Optional: Use 'auto' for instant scroll
                    });
                    setShow(false);
                } else if (okId === "ok") {
                    navToCat('/admin/displayCat');
                    setShow(false);
                }
            } else {
                setShow(true);
                setAction('something went wrong!')
                setNavv();
                setExtraBtn();
                setMore('ok');
            };

        } catch (e) {
            console.log(e, 'error in category post api');
            setShow(true);
            setAction('something went wrong!')
            setNavv();
            setExtraBtn();
            setMore('ok');
        };
    };

    // SUCCESSFULL HANDLE
    const [show, setShow] = useState(false);
    const [action, setAction] = useState();
    const [navv, setNavv] = useState();
    const [more, setMore] = useState();
    const [extraBtn, setExtraBtn] = useState();
    const navToCat = useNavigate();

    const handleSuccesBtn = () => {
        PostData("ok")
    };
    const handleCencel = () => {
        setShow(false);
    };

    const onMoreBtn = () => {
        PostData("addMore")
    };

    // Refs for scrolling
    const [errors, setErrors] = useState({});
    const titleRef = useRef(null);
    const handleValidation = () => {
        let newErrors = {};
        // Check each field
        if (!title?.trim()) newErrors.title = "Title is required.";
        setErrors(newErrors);

        // If there are errors, scroll to the first one
        if (Object.keys(newErrors).length > 0) {
            const firstErrorField = Object.keys(newErrors)[0];
            scrollToField(firstErrorField);
            return false;
        }

        return true;
    };

    const scrollToField = (field) => {
        switch (field) {
            case "title":
                titleRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            default:
                break;
        }
    };

    const handleSubmit = () => {
        handleValidation();
        if (handleValidation()) {
            setAction("Confirm Submit");
            setExtraBtn("Add More");
            setMore("cancel");
            setNavv("ok");
            setShow(true)
        }
    };


    return (
        <>
            <div className="add-item">
                <div className="row">
                    <div className="category-nav">
                        <div className="category-text">
                            <h4>Add Display Category</h4>
                        </div>
                        <div className="category-btn">
                            <button onClick={() => navigate(-1)}><RxCross1 /></button>
                        </div>
                    </div>
                    <hr />

                    <div className="main-container">
                        <div className="add-form" ref={titleRef}>

                            {/* Title Input */}
                            <div className="add w-100 m-b2">
                                <label style={errors.title && { color: "red" }}>Title</label>
                                <input
                                    type="text"
                                    name="title"
                                    onChange={(e) => { e.preventDefault(); setTitle(e.target.value) }}
                                    value={title}
                                />
                            </div>

                            <div className="editer m-b2">
                                <div className="add w-100">
                                    <label>Description</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: {
                                                items: [
                                                    "heading",
                                                    "|",
                                                    "bold",
                                                    "italic",
                                                    "link",
                                                    "bulletedList",
                                                    "numberedList",
                                                    "|",
                                                    "indent",
                                                    "outdent",
                                                    "|",
                                                    "imageUpload",
                                                    "blockQuote",
                                                    "mediaEmbed",
                                                    "undo",
                                                    "redo",
                                                ],
                                            },
                                        }}
                                        data={description}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setDescription(data);
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="btn submit-btn">
                        <button onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </div>

            {/* show SUCCESS */}

            <SuccessPopUp
                isOpen={show}
                action={action}
                onConfirm={handleSuccesBtn}
                navv={navv}
                onClose={handleCencel}
                FutherMore={more}
                moreBtn={extraBtn}
                onMoreBtn={onMoreBtn}
            />

        </>
    );
}

export default AddDisplayCat;

